import { render, staticRenderFns } from "./GarageModal.vue?vue&type=template&id=6a5d0f2e&"
import script from "./GarageModal.vue?vue&type=script&lang=js&"
export * from "./GarageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports